import React, { useRef } from "react";

/**
 * Take a photo of a paper document and upload it as a report.
 *
 * Mirrors PatientMeds.js:446-468 — `capture="environment"` opens the rear camera
 * directly on iPad rather than showing the photo-library sheet.
 *
 * Not `multiple`: one capture per press.
 */
export default function ReportCameraButton({ onCapture, disabled = false }) {
  const inputRef = useRef(null);

  const handleChange = (event) => {
    const file = event.target.files && event.target.files[0];
    // Reset FIRST (as PatientMeds does) so re-taking the same-named photo still
    // fires onChange — the value would otherwise be unchanged and the event suppressed.
    event.target.value = "";
    if (!file) return;
    onCapture(file);
  };

  return (
    <>
      <button
        type="button"
        disabled={disabled}
        title="Take a photo of a report and upload it"
        onClick={(e) => {
          // The MedStudent modal header is a drag handle — do not let this bubble.
          e.stopPropagation();
          if (!disabled) inputRef.current?.click();
        }}
        style={{
          fontSize: "13px",
          fontWeight: 600,
          padding: "6px 12px",
          borderRadius: "6px",
          border: "1px solid #2B6CB0",
          color: "#2B6CB0",
          backgroundColor: "transparent",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
        }}
      >
        📷 Take photo
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleChange}
        // inputRef.current.click() above dispatches a SECOND, bubbling click from
        // this input — a sibling of the button under the same parent — so without
        // this the button's own stopPropagation is defeated and the click still
        // reaches the MedStudent drag handle.
        onClick={(e) => e.stopPropagation()}
        style={{ display: "none" }}
        aria-hidden="true"
        tabIndex={-1}
      />
    </>
  );
}
